export const GAME_MODE_RULES = {
    classic: {
        id: 'classic',
        name: 'Classic Dominoes',
        description: 'Traditional dominoes - match the numbers',
        icon: '🎯',
        howToPlay: [
            'Match tiles with the same number of pips',
            'Place tiles on either end of the line',
            'Draw from boneyard if you cannot play',
            'First to empty hand wins the round',
            'Score points based on opponents\' remaining tiles'
        ],
        winCondition: 'First player to use all tiles wins',
        scoreSystem: 'Points equal sum of opponents\' remaining pips',
        specialRules: [
            'Doubles can be placed perpendicular',
            'Must announce "Last tile!" with one tile left'
        ],
        playerCount: 2,
        tilesPerPlayer: 7,
        maxPips: 6,
        canDraw: true,
        maxScore: 100,
        teamPlay: false
    },
    cutthroat: {
        id: 'cutthroat',
        name: 'Cutthroat (Three-Hand)',
        description: '3-player free-for-all, no partnerships',
        icon: '🎭',
        howToPlay: [
            'Three players compete individually',
            'Each player draws 9 tiles to start',
            'No teams - everyone for themselves',
            'Pass if you cannot play (no drawing)',
            'Score is sum of BOTH opponents\' pips'
        ],
        winCondition: 'First to 150 points wins',
        scoreSystem: 'Winner scores total of both opponents\' remaining pips',
        specialRules: [
            'Start with highest double',
            'More defensive play due to 2 opponents',
            'Temporary alliances may form'
        ],
        playerCount: 3,
        tilesPerPlayer: 9,
        maxPips: 6,
        canDraw: false,
        maxScore: 150,
        teamPlay: false
    },
    partner: {
        id: 'partner',
        name: 'Partner (Four-Hand)',
        description: 'Traditional 2v2 team dominoes',
        icon: '🤝',
        howToPlay: [
            'Four players in two teams',
            'Partners sit opposite each other',
            'Team score is combined',
            'Communication through plays only',
            'First team to 150 points wins'
        ],
        winCondition: 'First team to 150 points',
        scoreSystem: 'Winning team scores sum of losing team\'s pips',
        specialRules: [
            'No table talk allowed',
            'Must not reveal hand to partner',
            'Strategic blocking is key'
        ],
        playerCount: 4,
        tilesPerPlayer: 7,
        maxPips: 6,
        canDraw: false,
        maxScore: 150,
        teamPlay: true
    },
    sixlove: {
        id: 'sixlove',
        name: 'Six-Love (6-Love)',
        description: 'Jamaican rules - win 6 games straight for a skunk!',
        icon: '🇯🇲',
        howToPlay: [
            'Based on Partner Dominoes rules',
            'Win 6 consecutive games for "Six Love"',
            'Losing team gets "skunked" at 6-0',
            'Massive bragging rights for Six Love',
            'Common in Caribbean domino culture'
        ],
        winCondition: 'Win 6 games in a row for ultimate victory',
        scoreSystem: 'Standard partner scoring + streak tracking',
        specialRules: [
            'Six Love gives bonus points',
            'Streak resets if you lose',
            'Celebrations are mandatory!',
            'Trash talk encouraged'
        ],
        playerCount: 4,
        tilesPerPlayer: 7,
        maxPips: 6,
        canDraw: false,
        maxScore: 150,
        teamPlay: true
    },
    cross: {
        id: 'cross',
        name: 'Cross Dominoes',
        description: 'Four-directional play from center double',
        icon: '✚',
        howToPlay: [
            'First double placed in center',
            'Play extends in 4 directions',
            'Must play on all 4 arms before continuing',
            'More placement options available',
            'Common in tournaments'
        ],
        winCondition: 'First to empty hand wins',
        scoreSystem: 'Points from all 4 ends when multiple of 5',
        specialRules: [
            'Spinner (first double) creates cross',
            'All 4 sides must have tiles',
            'Then play continues normally',
            'Can score on multiple ends'
        ],
        playerCount: 4,
        tilesPerPlayer: 7,
        maxPips: 6,
        canDraw: false,
        maxScore: 150,
        startingTile: 'double',
        teamPlay: false
    },
    draw: {
        id: 'draw',
        name: 'Draw Dominoes',
        description: 'Must draw until you can play - fast paced!',
        icon: '⚡',
        howToPlay: [
            'MUST draw if cannot play',
            'Keep drawing until playable tile',
            'No passing allowed',
            'Boneyard can be depleted quickly',
            'Very fast-paced gameplay'
        ],
        winCondition: 'First to empty hand',
        scoreSystem: 'Standard pip counting',
        specialRules: [
            'Forced drawing creates action',
            'Hand size can grow large',
            'Boneyard management crucial',
            'No blocking strategies'
        ],
        playerCount: 2,
        tilesPerPlayer: 7,
        maxPips: 6,
        canDraw: true,
        maxScore: 100,
        teamPlay: false
    },
    allfives: {
        id: 'allfives',
        name: 'All Fives (Muggins)',
        description: 'Score when ends total multiples of 5',
        icon: '💯',
        howToPlay: [
            'Score during play, not just at end',
            'Add up all open ends',
            'Score if total is multiple of 5',
            'Each multiple of 5 = that many points',
            'Call "Muggins!" if opponent misses score'
        ],
        winCondition: 'First to 150 points',
        scoreSystem: 'Score = total of ends when divisible by 5',
        specialRules: [
            'Spinner counts all exposed ends',
            'Missing scores can be claimed',
            'Mental math is crucial',
            'Popular in USA and UK'
        ],
        playerCount: 2,
        tilesPerPlayer: 7,
        maxPips: 6,
        canDraw: true,
        maxScore: 150,
        teamPlay: false
    },
    block: {
        id: 'block',
        name: 'Block Dominoes',
        description: 'No drawing - pass if you can\'t play',
        icon: '🚫',
        howToPlay: [
            'Cannot draw from boneyard',
            'Must pass if no valid moves',
            'Game ends when blocked',
            'Winner has lowest pip count',
            'Very strategic blocking'
        ],
        winCondition: 'Lowest pip count when blocked',
        scoreSystem: 'Difference in pip counts',
        specialRules: [
            'No drawing makes blocking powerful',
            'Count pips carefully',
            'Defensive play is key',
            'Game can end in stalemate'
        ],
        playerCount: 2,
        tilesPerPlayer: 7,
        maxPips: 6,
        canDraw: false,
        maxScore: 100,
        teamPlay: false
    }
};
export function getGameRules(modeId) {
    return GAME_MODE_RULES[modeId] || GAME_MODE_RULES.classic;
}
export function getHowToPlayText(modeId) {
    const rules = getGameRules(modeId);
    return `
    <h2 style="color: #ffd700; font-size: clamp(20px, 4vw, 28px); margin-bottom: 8px;">${rules.icon} ${rules.name}</h2>
    <p style="color: #94a3b8; font-size: 15px; margin-bottom: 20px;">${rules.description}</p>

    <h3 style="color: #e2e8f0; font-size: 16px; margin-bottom: 8px; border-bottom: 1px solid rgba(255,255,255,0.1); padding-bottom: 6px;">How to Play</h3>
    <ul style="color: #cbd5e1; font-size: 14px; line-height: 1.8; padding-left: 20px; margin-bottom: 16px;">
      ${rules.howToPlay.map(rule => `<li style="margin-bottom: 4px;">${rule}</li>`).join('')}
    </ul>

    <h3 style="color: #e2e8f0; font-size: 16px; margin-bottom: 8px; border-bottom: 1px solid rgba(255,255,255,0.1); padding-bottom: 6px;">Win Condition</h3>
    <p style="color: #cbd5e1; font-size: 14px; line-height: 1.6; margin-bottom: 16px;">${rules.winCondition}</p>

    <h3 style="color: #e2e8f0; font-size: 16px; margin-bottom: 8px; border-bottom: 1px solid rgba(255,255,255,0.1); padding-bottom: 6px;">Scoring</h3>
    <p style="color: #cbd5e1; font-size: 14px; line-height: 1.6; margin-bottom: 16px;">${rules.scoreSystem}</p>

    <h3 style="color: #e2e8f0; font-size: 16px; margin-bottom: 8px; border-bottom: 1px solid rgba(255,255,255,0.1); padding-bottom: 6px;">Special Rules</h3>
    <ul style="color: #cbd5e1; font-size: 14px; line-height: 1.8; padding-left: 20px; margin-bottom: 16px;">
      ${rules.specialRules.map(rule => `<li style="margin-bottom: 4px;">${rule}</li>`).join('')}
    </ul>

    <div style="
      margin-top: 16px; padding: 12px 16px;
      background: rgba(255,255,255,0.08); border-radius: 12px;
      display: grid; grid-template-columns: 1fr 1fr; gap: 8px;
      font-size: 13px; color: #94a3b8;
    ">
      <div><strong style="color: #e2e8f0;">Players:</strong> ${rules.playerCount}</div>
      <div><strong style="color: #e2e8f0;">Tiles:</strong> ${rules.tilesPerPlayer} each</div>
      <div><strong style="color: #e2e8f0;">Can Draw:</strong> ${rules.canDraw ? 'Yes' : 'No'}</div>
      <div><strong style="color: #e2e8f0;">Target:</strong> ${rules.maxScore} pts</div>
    </div>
  `;
}
